define('app/sds/report/definition/menu/sds-report-definition-menu-service',["service!selcomm", "$q", "service!selcomm:filter"], function (SelcommWS, $q, filter) {
	"use strict";
	var ReportList = SelcommWS.prepare.cached.post("Reports", "ReportList");
	return function sdsReportDefinitionMenuService(selected) {
		return $q(function ($return, $throw) {
			ReportList({
				PagingSortsAndFilters: {
					Filter: filter.compare("Category.Id", "=", selected.Id)
				}
			})
				.then(function (reportList) {
					$return((reportList.Items || reportList).map(function (report) {
						return {
							//ImageUrl: reportCategory.ImageUrl,
							Id: report.ReportId,
							Caption: report.Name,
							ChildMenuItems: [{
								Id: 1,
								Caption: "Run",
								ItemMode: "Directive",
								Component: {
									tag: "ap-demo-underconstruction",
									attrs: {
										"{[displayName]}": "Run"
									}
								}
							}, {
								Id: 2,
								Caption: "Schedule",
								ItemMode: "Directive",
								Component: {
									tag: "ap-demo-underconstruction",
									attrs: {
										"{[displayName]}": "Schedule"
									}
								}
							}, {
								Id: 3,
								Caption: "History",
								ItemMode: "Directive",
								Component: {
									tag: "ap-demo-underconstruction",
									attrs: {
										"{[displayName]}": "History"
									}
								}
							}],
							ItemMode: "Directive",
							Component: {
								tag: "sds-report-requested-view",
								attrs: {
									reportId: report.ReportId
								}
							}
						};
					}));
				})
				.catch(function (err) {
					$throw(err);
				});
		});
	}
});
